require("!!/Users/zhaolinxu/GitHub/IdleAnt/node_modules/script-loader/addScript.js")(require("!!/Users/zhaolinxu/GitHub/IdleAnt/node_modules/raw-loader/index.js!/Users/zhaolinxu/GitHub/IdleAnt/node_modules/@webcomponents/custom-elements/custom-elements.min.js"))


//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/~/script-loader!/Users/zhaolinxu/GitHub/IdleAnt/~/@webcomponents/custom-elements/custom-elements.min.js
// module id = ../../../../script-loader/index.js!../../../../@webcomponents/custom-elements/custom-elements.min.js
// module chunks = 3